import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right-arrow",
  "use": "icon-right-arrow-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol viewBox=\"0 0 8 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right-arrow\">\n<path d=\"M1 1L7 7L1 13\" stroke=\"\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol